window.initAccordions = () => {
  document.querySelectorAll('.collection-filter-group').forEach((el, i) => {
    if (!i) el.classList.add('active');
    let body = el.querySelector('.collection-filter-group__body');
    if (!body) return;
    body.style.overflow = 'hidden';
    let ul = body.querySelector('ul'), 
        h = ul ? ul.offsetHeight : body.scrollHeight;
    body.style.maxHeight = el.classList.contains('active') ? (h ? h + 'px' : '1500px') : '0';
    let title = el.querySelector('.collection-filter-group__title');
    if (title) title.setAttribute('aria-expanded', el.classList.contains('active') ? 'true' : 'false');
    if (!el.classList.contains('active')) body.inert = true;
  });
};
document.addEventListener("DOMContentLoaded", () => {
  window.initAccordions();
  document.addEventListener('click', e => {
    let title = e.target.closest('.collection-filter-group__title,.quick-size-btn');
    if (!title) return;
    e.preventDefault();
    let item = title.closest('.collection-filter-group,.quick-size'),
        body = item ? item.querySelector('.collection-filter-group__body,.quick-size .collection-filter-form') : null;
    if (!body) return;
    let wasActive = item.classList.contains('active');
    document.querySelectorAll('.collection-filter-group,.quick-size').forEach(el => {
      el.classList.remove('active');
      let b = el.querySelector('.collection-filter-group__body,.quick-size .collection-filter-form');
      if (b) { b.style.maxHeight = '0'; b.inert = true; }
      let t = el.querySelector('.collection-filter-group__title');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    if (!wasActive) {
      item.classList.add('active');
      let ul = body.querySelector('ul');
      body.style.maxHeight = (ul ? ul.offsetHeight : body.scrollHeight) + 'px';
      body.inert = false;
      let t = item.querySelector('.collection-filter-group__title');
      if (t) t.setAttribute('aria-expanded', 'true');
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Enter') return;
    let input = e.target;
    if ((input.type === 'checkbox' || input.type === 'radio') && input.closest('.collection-filter-label')) {
      e.preventDefault();
      input.click();
    }
  });
});
/**
 * Collection page
 *
 * Handles:
 * - Filter drawer open / close with focus trap & a11y
 * - AJAX filtering with dynamic "Show x results" button
 * - Sort select
 * - Infinite scroll (auto), load-more button, or classic pagination
 * - URL updates (?page=x, filter params, sort_by)
 */

  (function () {
  'use strict';

  var section = document.querySelector('.section-collection');
  if (!section) return;

  // Drawer starts closed — remove it from tab order immediately
  var _initDrawer = section.querySelector('.collection-filter-drawer');
  if (_initDrawer) _initDrawer.inert = true;

  var SECTION_ID  = section.dataset.sectionId;
  var LOAD_MODE   = section.dataset.loadMore || 'auto_scroll';

  var isLoading     = false;
  var _prevFocused  = null;

  /* ── helpers ───────────────────────────────────────────────── */

  function updateURL(url, replace) {
    if (replace) {
      window.history.replaceState({}, '', url);
    } else {
      window.history.pushState({}, '', url);
    }
  }

  function fetchSectionDoc(url) {
    var separator = url.indexOf('?') > -1 ? '&' : '?';
    var fetchUrl  = url + separator + 'sections=' + SECTION_ID;

    return fetch(fetchUrl)
      .then(function (res) { return res.json(); })
      .then(function (json) {
        var html = json[SECTION_ID];
        if (!html) throw new Error('Section not found in response');
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  /* ── Dynamic Filter Counts ─────────────────────────────────── */

    /* ── Dynamic Filter Counts ─────────────────────────────────── */

  function updateFilterCounts() {
    var drawer = getFilterDrawer();
    var filterContainer = section; 
    if (!filterContainer) return;

    var totalActive = 0;
    var groups = filterContainer.querySelectorAll('.collection-filter-group');

    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var groupCount = 0;

      var checkboxes = group.querySelectorAll('input[type="checkbox"]:checked');
      groupCount += checkboxes.length;

      var priceMin = group.querySelector('.range-min');
      var priceMax = group.querySelector('.range-max');
      if (priceMin && priceMax) {
        var minVal = parseInt(priceMin.value, 10) || 0;
        var maxVal = parseInt(priceMax.value, 10) || 0;
        var minLimit = parseInt(priceMin.min, 10) || 0;
        var maxLimit = parseInt(priceMax.max, 10) || 0;
        
        var priceWrapper = group.querySelector('.collection-filter-price');
        if (minVal > minLimit || maxVal < maxLimit) {
          groupCount += 1;
        }
        if (priceWrapper) {
          priceWrapper.classList.remove('active-min', 'active-max');
          if (minVal > minLimit) {
            priceWrapper.classList.add('active-min');
          } 
          if (maxVal < maxLimit) {
            priceWrapper.classList.add('active-max');
          }
        }
      }

      var title = group.querySelector('.coll-filter-title');
      if (title) {
        var countEl = title.querySelector('.filter-count');
        
        if (groupCount > 0) {
          if (!countEl) {
            countEl = document.createElement('span');
            countEl.className = 'filter-count';
            title.appendChild(document.createTextNode(' '));
            title.appendChild(countEl);
          }
          countEl.textContent = '(' + groupCount + ')';
        } else if (countEl) {
          countEl.remove();
        }
      }

      totalActive += groupCount;
    }

    // === QUICK SIZE BUTTON COUNT LOGIC ===
    var quickSizeWrap = document.querySelector('.quick-size-wrap');
    var quickSizeBtnCount = document.querySelector('.quick-size-btn .filter-count');
    
    if (quickSizeWrap && quickSizeBtnCount) {
      // Find how many checkboxes are selected inside the quick filter wrap
      var quickSizeChecked = quickSizeWrap.querySelectorAll('input[type="checkbox"]:checked').length;
      if (quickSizeChecked > 0) {
        quickSizeBtnCount.textContent = '(' + quickSizeChecked + ')';
      } else {
        // Clear it if nothing is selected
        quickSizeBtnCount.textContent = '';
      }
    }
    // =====================================
    
    var appliedCountEl = document.querySelector('.applied-filter-count');
    if (appliedCountEl) {
      if(totalActive > 0){
        appliedCountEl.classList.add('active');
      } else {
        appliedCountEl.classList.remove('active');
      }
      appliedCountEl.textContent = totalActive;
    }

    // Toggle clear-all button visibility based on active filters
    var clearBtn = section.querySelector('.collection-filter-clear');
    if (clearBtn) {
      if (totalActive > 0) {
        clearBtn.classList.add('active-btn');
      } else {
        clearBtn.classList.remove('active-btn');
      }
    }
  }



  /* ── Price Sliders Functionality ──────────────────────────── */

  function initPriceSliders() {
    var wrappers = document.querySelectorAll('.range-slider-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      if (wrapper.dataset.initialized) continue;
      wrapper.dataset.initialized = 'true';

      (function(wrap) {
        var rangeMin = wrap.querySelector('.range-min');
        var rangeMax = wrap.querySelector('.range-max');
        var minValDisplay = wrap.querySelector('.min-val');
        var maxValDisplay = wrap.querySelector('.max-val');
        var hiddenMin = wrap.querySelector('.input-min-hidden');
        var hiddenMax = wrap.querySelector('.input-max-hidden');

        if (!rangeMin || !rangeMax) return;

        function updateSlider(e) {
          var minPrice = parseInt(rangeMin.value) || 0;
          var maxPrice = parseInt(rangeMax.value) || 0;

          if (maxPrice < minPrice) {
            if (e && e.target === rangeMin) {
              rangeMin.value = maxPrice;
              minPrice = maxPrice;
            } else if (e && e.target === rangeMax) {
              rangeMax.value = minPrice;
              maxPrice = minPrice;
            }
          }

          minValDisplay.textContent = minPrice;
          maxValDisplay.textContent = maxPrice;
          hiddenMin.value = minPrice;
          hiddenMax.value = maxPrice;

          updateFilterCounts();
        }

        rangeMin.addEventListener('input', updateSlider);
        rangeMax.addEventListener('input', updateSlider);
      })(wrapper);
    }
  }

  /* ── Products-only replacement (preserves filter drawer & accordion state) ── */

  function replaceProductsOnly(doc) {
    var newSection = doc.querySelector('.section-collection');
    if (!newSection) return;

    // Update section data attributes
    if (newSection.dataset.productsCount !== undefined) section.dataset.productsCount = newSection.dataset.productsCount;
    if (newSection.dataset.totalPages !== undefined)    section.dataset.totalPages    = newSection.dataset.totalPages;
    if (newSection.dataset.currentPage !== undefined)  section.dataset.currentPage   = newSection.dataset.currentPage;

    // Replace only the product grid
    var productGrid = section.querySelector('.collection-grid');
    var newGrid     = newSection.querySelector('.collection-grid');
    if (productGrid && newGrid) {
      productGrid.innerHTML = newGrid.innerHTML;
    }

    // Update load-more link
    var loadMore    = section.querySelector('[data-load-more]');
    var newLoadMore = newSection.querySelector('[data-load-more]');
    if (loadMore) {
      if (newLoadMore && newLoadMore.getAttribute('href')) {
        loadMore.setAttribute('href', newLoadMore.getAttribute('href'));
        loadMore.style.display = '';
      } else {
        loadMore.style.display = 'none';
        if (autoScrollObserver) autoScrollObserver.disconnect();
      }
    }

    // Update pagination info
    var paginationInfo    = section.querySelector('.collection-pagination-info');
    var newPaginationInfo = newSection.querySelector('.collection-pagination-info');
    if (paginationInfo && newPaginationInfo) {
      paginationInfo.innerHTML = newPaginationInfo.innerHTML;
    }

    // Update apply button count
    var count    = newSection.dataset.productsCount || '0';
    var applyBtn = section.querySelector('.collection-filter-apply');
    if (applyBtn) {
      applyBtn.textContent = applyBtn.textContent.replace(/\d+/, count);
    }

    // Update collection count in header
    var collectionCount = section.querySelector('.collection-count');
    if (collectionCount) collectionCount.textContent = count;

    // Sync disabled states for filter inputs from the fetched doc
    var newFilterInputs = newSection.querySelectorAll('.collection-filter-drawer input[type="checkbox"], .collection-filter-drawer input[type="radio"]');
    for (var di = 0; di < newFilterInputs.length; di++) {
      var ni = newFilterInputs[di];
      if (!ni.name || !ni.value) continue;
      var matches = section.querySelectorAll(
        'input[name="' + ni.name.replace(/"/g, '\\"') + '"][value="' + ni.value.replace(/"/g, '\\"') + '"]'
      );
      for (var mi = 0; mi < matches.length; mi++) {
        matches[mi].disabled = ni.disabled;
        var item = matches[mi].closest('.collection-filter-item');
        if (item) {
          if (ni.disabled) {
            item.classList.add('is-disabled');
          } else {
            item.classList.remove('is-disabled');
          }
        }
      }
    }

    if (typeof quickAddButton === 'function') quickAddButton();
    if (typeof initProductSliders === 'function') initProductSliders();

    if (LOAD_MODE === 'auto_scroll') {
      initAutoScroll();
    }
  }

  /* ── Section replacement (for filter / sort / popstate) ───── */

  function replaceSection(doc) {
    var newSection = doc.querySelector('.section-collection');
    if (newSection && section.parentNode) {
      section.parentNode.replaceChild(newSection, section);
      section = newSection;

      if (LOAD_MODE === 'auto_scroll') {
        initAutoScroll();
      }

      if (typeof quickAddButton === 'function') {
        quickAddButton();
      }

      if (typeof window.initAccordions === 'function') {
        window.initAccordions();
      }
      
      if (typeof initProductSliders === 'function') initProductSliders();
      
      initPriceSliders(); 
      updateFilterCounts(); 
    }
  }

  /* ── Filter drawer ─────────────────────────────────────────── */

  function getFilterDrawer() {
    return section.querySelector('.collection-filter-drawer');
  }

  function openFilterDrawer() {
    var drawer = getFilterDrawer();
    if (!drawer) return;
    _prevFocused = document.activeElement;
    drawer.inert = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('open-filter');
    drawer.focus();
  }

  function closeFilterDrawer() {
    var drawer = getFilterDrawer();
    document.body.classList.remove('open-filter');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.inert = true;
    }
    if (_prevFocused && _prevFocused.focus) _prevFocused.focus({ preventScroll: true });
  }

  /* ── Availability injection ───────────────────────────────── */

  function injectAvailabilityForSize(params) {
    var hasSize = false;
    params.forEach(function (value, key) {
      if (key.toLowerCase().indexOf('size') > -1) {
        hasSize = true;
      }
    });
    if (hasSize) {
      params.set('filter.v.m.online.available', '1');
    }
  }

  /* ── Dynamic "Show x results" on filter changes ────────────── */

  function updateResultCount() {
    var drawer = getFilterDrawer();
    if (!drawer) return;

    var form = drawer.querySelector('.collection-filter-form');
    if (!form) return;

    var formData = new FormData(form);
    var params   = new URLSearchParams();

    for (var pair of formData.entries()) {
      if (pair[1]) params.append(pair[0], pair[1]);
    }

    var sortInput = section.querySelector('input[name="sort_by"]:checked');
    if (sortInput && sortInput.value) {
      params.set('sort_by', sortInput.value);
    }

    injectAvailabilityForSize(params);

    var fetchUrl = form.dataset.collectionUrl + '?' + params.toString();

    fetchSectionDoc(fetchUrl)
      .then(function (doc) {
        var newSection = doc.querySelector('.section-collection');
        if (!newSection) return;

        var count = newSection.dataset.productsCount || '0';
        var applyBtn = drawer.querySelector('.collection-filter-apply');
        if (applyBtn) {
          applyBtn.textContent = applyBtn.textContent.replace(/\d+/, count);
        }

        // Update collection count in header
        var collectionCount = section.querySelector('.collection-count');
        if (collectionCount) collectionCount.textContent = count;
      })
      .catch(console.error);
  }

  /* ── Filter form submit ────────────────────────────────────── */

  /* અહી isAutoSubmit پیرામીટર ઉમેરેલ છે, જેથી quick filter માં scroll-up ન થાય */
  function handleFilterSubmit(e, isAutoSubmit) {
    if (e && e.preventDefault) e.preventDefault();
    var form     = e.target;
    var formData = new FormData(form);
    var params   = new URLSearchParams();

    for (var pair of formData.entries()) {
      if (pair[1]) params.append(pair[0], pair[1]);
    }

    var sortInput = section.querySelector('input[name="sort_by"]:checked');
    if(sortInput && sortInput.value){
      params.set('sort_by', sortInput.value);
    }

    injectAvailabilityForSize(params);

    var newUrl = form.dataset.collectionUrl + '?' + params.toString();

    updateURL(newUrl);

    fetchSectionDoc(newUrl)
      .then(function (doc) {
        if (isAutoSubmit) {
          replaceProductsOnly(doc);
        } else {
          replaceSection(doc);
          closeFilterDrawer();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      })
      .catch(console.error);
  }

  /* ── Sort ──────────────────────────────────────────────────── */

  function handleSort(e) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');

    updateURL(url.toString());

    fetchSectionDoc(url.toString())
      .then(function (doc) {
        replaceSection(doc);
      })
      .catch(console.error);
  }
  
  /* ── Load more / infinite scroll ───────────────────────────── */

  function loadNextPage(loadMoreEl) {
    if (isLoading || !loadMoreEl) return;

    var nextUrl = loadMoreEl.getAttribute('href');
    if (!nextUrl) return;

    isLoading = true;
    loadMoreEl.classList.add('is-loading');

    fetchSectionDoc(nextUrl)
      .then(function (doc) {
        var productGrid = section.querySelector('.collection-grid');
        var newGrid     = doc.querySelector('.collection-grid');

        if (newGrid && productGrid) {
          var items = newGrid.querySelectorAll('.product-item, .collection-promo-card');
          for (var i = 0; i < items.length; i++) {
            productGrid.appendChild(items[i]);
          }
        }

        var nextLink = doc.querySelector('[data-load-more]');
        var hasMore  = false;

        if (nextLink && nextLink.getAttribute('href')) {
          loadMoreEl.setAttribute('href', nextLink.getAttribute('href'));
          hasMore = true;
        } else {
          var newSection = doc.querySelector('.section-collection');
          if (newSection) {
            var totalPages  = parseInt(newSection.dataset.totalPages) || 0;
            var currentPage = parseInt(newSection.dataset.currentPage) || 0;
            if (currentPage < totalPages) {
              var nextPageUrl = new URL(nextUrl, window.location.origin);
              nextPageUrl.searchParams.set('page', currentPage + 1);
              loadMoreEl.setAttribute('href', nextPageUrl.pathname + nextPageUrl.search);
              hasMore = true;
            }
          }
        }

        if (hasMore) {
          loadMoreEl.style.display = '';
        } else {
          loadMoreEl.style.display = 'none';
          if (autoScrollObserver) autoScrollObserver.disconnect();
        }

        var liveInfo = section.querySelector('.collection-pagination-info');
        var newInfo  = doc.querySelector('.collection-pagination-info');
        if (liveInfo && newInfo) {
          liveInfo.innerHTML = newInfo.innerHTML;
        } else if (liveInfo && !hasMore) {
          var totalPages = section.dataset.totalPages || '?';
          liveInfo.textContent = liveInfo.textContent.replace(/\d+(\s*(?:of|\/)\s*)\d+/, totalPages + '$1' + totalPages);
        }

        try {
          var urlObj    = new URL(nextUrl, window.location.origin);
          var page      = urlObj.searchParams.get('page');
          if (page) {
            var currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('page', page);
            updateURL(currentUrl.toString(), true);
            section.dataset.currentPage = page;
          }
        } catch (e) { }

        if (typeof quickAddButton === 'function') quickAddButton();
        if (typeof initProductSliders === 'function') initProductSliders();
      })
      .catch(function (err) {
        console.error('Load more error:', err);
      })
      .finally(function () {
        isLoading = false;
        loadMoreEl.classList.remove('is-loading');
      });
  }

  /* ── Auto scroll observer ──────────────────────────────────── */

  var autoScrollObserver = null;

  function initAutoScroll() {
    if (autoScrollObserver) autoScrollObserver.disconnect();

    var loadMoreEl = section.querySelector('.collection-load-more--auto[data-load-more]');
    if (!loadMoreEl) return;

    autoScrollObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !isLoading) {
          loadNextPage(loadMoreEl);
        }
      });
    }, { rootMargin: '200px' });

    autoScrollObserver.observe(loadMoreEl);
  }

  /* ── Delegated event listeners ─────────────────────────────── */

  var overlay = document.querySelector('.overlay-box');
  if (overlay) {
    overlay.addEventListener('click', function () {
      if (document.body.classList.contains('open-filter')) {
        closeFilterDrawer();
      }
    }, true);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.collection-filter-toggle')) {
      openFilterDrawer();
      return;
    }

    if (e.target.closest('.collection-filter-close')) {
      closeFilterDrawer();
      return;
    }

    var drawer = getFilterDrawer();
    if (drawer && document.body.classList.contains('open-filter') && e.target === drawer) {
      closeFilterDrawer();
      return;
    }

    var applyBtn = e.target.closest('.collection-filter-apply');
    if (applyBtn) {
      e.preventDefault();
      closeFilterDrawer();
      return;
    }

    var loadMoreBtn = e.target.closest('.collection-load-more--btn[data-load-more]');
    if (loadMoreBtn) {
      e.preventDefault();
      loadNextPage(loadMoreBtn);
      return;
    }

    var shopBtn = e.target.closest('.shop-look-button');
    if (shopBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var shopUrl   = shopBtn.getAttribute('data-url');
      var shopModal = shopBtn.getAttribute('data-modal');
      fetch(shopUrl)
        .then(function (response) { return response.text(); })
        .then(function (response) {
          var html   = new DOMParser().parseFromString(response, 'text/html');
          var source = html.getElementById('section-shop-look');
          document.body.classList.add('open-shop-look');
          document.getElementById(shopModal).getElementsByClassName('shop-look-popup')[0].innerHTML = source.innerHTML;
          addToCart();
        })
        .catch(function (err) { console.error(err); });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('open-filter')) {
      closeFilterDrawer();
      return;
    }

    if (e.key === 'Tab' && document.body.classList.contains('open-filter')) {
      var drawer = getFilterDrawer();
      if (!drawer) return;

      var focusable = drawer.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), details > summary'
      );
      if (!focusable.length) return;

      var first = focusable[0];
      var last  = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  });

  /* Submit Form Binding - content updates dynamically; just close the drawer on submit */
  document.addEventListener('submit', function (e) {
    if (e.target.matches('.collection-filter-form') || e.target.closest('.collection-filter-form')) {
      e.preventDefault();
      closeFilterDrawer();
    }
  });

  /* Checkbox / Radio change */
  document.addEventListener('change', function (e) {
    if (e.target.name === 'sort_by') {
      handleSort(e);
    }

    if (e.target.closest('.collection-filter-form')) {

      // 1. Sync inputs between drawer and quick filter (બંને form ના સાઈઝના checkbox એકીસાથે check/uncheck રહે)
      if (e.target.type === 'checkbox' || e.target.type === 'radio') {
        var duplicates = section.querySelectorAll(
          'input[name="' + e.target.name + '"][value="' + e.target.value + '"]'
        );
        for (var i = 0; i < duplicates.length; i++) {
          if (duplicates[i] !== e.target) {
            duplicates[i].checked = e.target.checked;
          }
        }
      }

      updateFilterCounts();

      // Auto-submit on every filter change (drawer or quick filter)
      var drawer = getFilterDrawer();
      var mainForm = drawer ? drawer.querySelector('.collection-filter-form') : e.target.closest('.collection-filter-form');
      if (mainForm) {
        handleFilterSubmit({ target: mainForm, preventDefault: function(){} }, true);
      }

    }
  });

  /* Filter range inputs */
  document.addEventListener('input', function (e) {
    if (e.target.closest('.collection-filter-price input')) {
      clearTimeout(e.target._debounce);
      e.target._debounce = setTimeout(function() {
        var drawer = getFilterDrawer();
        var mainForm = drawer ? drawer.querySelector('.collection-filter-form') : null;
        if (mainForm) {
          handleFilterSubmit({ target: mainForm, preventDefault: function(){} }, true);
        }
      }, 400);
    }
  });

  /* Form reset fallback */
  document.addEventListener('reset', function (e) {
    if (e.target.closest('.collection-filter-form')) {
      setTimeout(updateFilterCounts, 10);
    }
  });

  /* Browser back/forward */
  window.addEventListener('popstate', function () {
    fetchSectionDoc(window.location.href)
      .then(function (doc) {
        replaceSection(doc);
      })
      .catch(console.error);
  });

  /* ── Load previous pages on refresh (infinite scroll / load-more) ── */

  function loadPreviousPages() {
    var currentPage = parseInt(section.dataset.currentPage) || 1;
    if (currentPage <= 1) return;

    var productGrid = section.querySelector('.collection-grid');
    if (!productGrid) return;

    var baseUrl = new URL(window.location.href);
    var promises = [];

    for (var p = 1; p < currentPage; p++) {
      var pageUrl = new URL(baseUrl.toString());
      pageUrl.searchParams.set('page', String(p));
      promises.push(fetchSectionDoc(pageUrl.toString()));
    }

    section.classList.add('is-loading-previous');

    Promise.all(promises)
      .then(function (docs) {
        var fragment = document.createDocumentFragment();

        for (var i = 0; i < docs.length; i++) {
          var newGrid = docs[i].querySelector('.collection-grid');
          if (!newGrid) continue;
          var items = newGrid.querySelectorAll('.product-item, .collection-promo-card');
          for (var j = 0; j < items.length; j++) {
            fragment.appendChild(items[j]);
          }
        }

        // Preserve scroll position while prepending
        var scrollBefore = window.pageYOffset;
        var heightBefore = document.documentElement.scrollHeight;

        productGrid.insertBefore(fragment, productGrid.firstChild);

        requestAnimationFrame(function () {
          var heightAfter = document.documentElement.scrollHeight;
          window.scrollTo(0, scrollBefore + (heightAfter - heightBefore));
        });

        section.classList.remove('is-loading-previous');

        if (typeof quickAddButton === 'function') quickAddButton();
        if (typeof initProductSliders === 'function') initProductSliders();
      })
      .catch(function (err) {
        console.error('Error loading previous pages:', err);
        section.classList.remove('is-loading-previous');
      });
  }

  /* ── Init ──────────────────────────────────────────────────── */

  if (LOAD_MODE === 'auto_scroll') {
    initAutoScroll();
  }

  if (LOAD_MODE !== 'pagination') {
    loadPreviousPages();
  }
  
  initPriceSliders();
  updateFilterCounts(); 

})();


document.addEventListener("DOMContentLoaded", function(){
  let desc = document.querySelector(".collection-desc");
  let btn = document.querySelector(".desc-toggle");
  if(!desc || !btn) return;
  if(desc.scrollHeight > desc.clientHeight) {
    btn.style.display = "inline-block";
  }
  btn.addEventListener("click", function(){
    desc.classList.toggle("expanded");
  });
});
document.addEventListener("DOMContentLoaded", function() {
  const slider = document.querySelector('.top_ul_nav');
  if(!slider) return;
  
  let isDown = false;
  let isDragging = false;
  let startX;
  let scrollLeft;
  
  // Prevent native drag behavior on links (ghost dragging)
  slider.querySelectorAll('a').forEach(a => {
    a.addEventListener('dragstart', (e) => e.preventDefault());
  });

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    isDragging = false;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  
  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2; // scroll speed
    
    // Mark as dragging only if there's actual movement (> 5px)
    if (Math.abs(x - startX) > 5) {
      isDragging = true;
    }
    
    if (isDragging) {
      e.preventDefault();
      slider.scrollLeft = scrollLeft - walk;
    }
  });

  // Capture clicks on the slider
  slider.addEventListener('click', (e) => {
    if (isDragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
});